// Centralized site constants for TamilBTC
export const COMPANY = {
  name: "TamilBTC Technologies",
  tagline: "Tamil Nadu's Digital Energy & Security Company",
  slogan: "Power More. Save More. Earn More.",
  phone: "8883335220",
  phoneDisplay: "+91 88833 35220",
  whatsapp: "918883335220",
  email: "contact@tamilbtc.in",
  website: "www.tamilbtc.in",
  logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_solar-cctv-ev/artifacts/wciib8hc_ChatGPT%20Image%2020%20%E0%AE%9C%E0%AF%82%E0%AE%A9%E0%AF%8D%2C%202026%2C%2010_54_20%20PM.png",
  address: {
    line1: "2-68B, Kumbakonam Bypass Road",
    line2: "Uthani Village, Papanasam",
    city: "Thanjavur",
    pincode: "614208",
    state: "Tamil Nadu",
  },
  founder: "Rtn. Er. R. Vinothkumar",
  founderRole: "CEO",
  experienceYears: "13+",
  projects: "500+",
  customers: "1000+",
};

export const DEALER_BRANDS = ["Microtek", "UTL", "Luminous", "Eastman", "Livguard", "Exide", "Growatt", "Waaree"];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1658298775754-5839ffd434cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxzb2xhciUyMHBhbmVscyUyMHJvb2Z8ZW58MHx8fHwxNzgxODg5MzgyfDA&ixlib=rb-4.1.0&q=85",
  solar: "https://images.unsplash.com/photo-1613665813446-82a78c468a1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVscyUyMHJvb2Z8ZW58MHx8fHwxNzgxODg5MzgyfDA&ixlib=rb-4.1.0&q=85",
  cctv: "https://images.pexels.com/photos/18124167/pexels-photo-18124167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ev: "https://images.pexels.com/photos/37807346/pexels-photo-37807346.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  power: "https://images.unsplash.com/photo-1611365892117-bce8d4a3027f?auto=format&fit=crop&w=1200&q=80",
  digital: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=1200&q=80",
  founder: "https://customer-assets.emergentagent.com/job_solar-cctv-ev/artifacts/2w7hatn4_IMG20260329135543.jpg",
};

export const DIVISIONS = [
  {
    key: "solar",
    title: "Solar Energy",
    icon: "Sun",
    desc: "Residential, Commercial & Industrial rooftop solar with PM Surya Ghar subsidy.",
    accent: "bg-amber-400",
    image: IMAGES.solar,
    href: "/solar",
  },
  {
    key: "cctv",
    title: "Security Solutions",
    icon: "VideoCamera",
    desc: "CCTV, Access Control & Biometrics for homes, offices and factories.",
    accent: "bg-slate-900",
    image: IMAGES.cctv,
    href: "/cctv",
  },
  {
    key: "ev",
    title: "Electric Mobility",
    icon: "Lightning",
    desc: "Electric scooters, EV chargers and after-sales service.",
    accent: "bg-emerald-500",
    image: IMAGES.ev,
    href: "/ev",
  },
  {
    key: "power",
    title: "Power Backup",
    icon: "BatteryCharging",
    desc: "UPS, Inverter & Lithium battery systems for uninterrupted power.",
    accent: "bg-blue-500",
    image: IMAGES.power,
    href: "/solar",
  },
  {
    key: "digital",
    title: "Digital Infrastructure",
    icon: "Browsers",
    desc: "Websites, AI automation & CRM that grow your business.",
    accent: "bg-violet-500",
    image: IMAGES.digital,
    href: "/contact",
  },
];

export const PROJECTS = [
  { id: 1, title: "10kW Rooftop Solar — Kumbakonam Hospital", category: "Solar", image: IMAGES.solar, span: "lg:col-span-8" },
  { id: 2, title: "32-Camera CCTV Surveillance — Textile Factory", category: "CCTV", image: IMAGES.cctv, span: "lg:col-span-4" },
  { id: 3, title: "EV Scooter Fleet Delivery — Thanjavur", category: "EV", image: IMAGES.ev, span: "lg:col-span-4" },
  { id: 4, title: "5kW Hybrid Solar + Battery — Residence", category: "Solar", image: IMAGES.solar, span: "lg:col-span-4" },
  { id: 5, title: "Smart Office Automation — Papanasam", category: "Digital", image: IMAGES.digital, span: "lg:col-span-4" },
];

export const TESTIMONIALS = [
  { name: "Murugan S.", role: "Homeowner, Kumbakonam", text: "TamilBTC installed our 3kW solar system in just 3 days. Bill dropped from ₹4,200 to ₹350. Excellent service.", rating: 5 },
  { name: "Lakshmi Industries", role: "Textile Factory, Thanjavur", text: "32-camera CCTV with NVR — flawless installation and the mobile app works perfectly. Highly professional.", rating: 5 },
  { name: "Karthik R.", role: "EV Customer", text: "Bought my electric scooter from them. Smooth delivery, great battery backup and free home charger installation.", rating: 5 },
  { name: "Dr. Senthil", role: "Hospital Administrator", text: "From solar to backup power to surveillance — TamilBTC handled it end-to-end. Single point of contact.", rating: 5 },
  { name: "Priya M.", role: "Residential Customer", text: "Founder Vinothkumar personally visited the site. Genuine pricing, no hidden costs. Truly Tamil Nadu's pride.", rating: 5 },
];

export const FAQS_SOLAR = [
  { q: "Am I eligible for the PM Surya Ghar subsidy?", a: "Residential homeowners installing 1-10kW grid-tied rooftop solar are eligible. Subsidy ranges from ₹30,000 (1kW) up to ₹78,000 (3kW & above). TamilBTC handles the entire application." },
  { q: "How long does a solar battery last?", a: "Lithium batteries we install last 8-10 years with 10,000+ cycles. Lead-acid alternatives last 3-5 years." },
  { q: "What is the payback period?", a: "For a typical TN home with ₹3,000+ monthly bill, on-grid solar pays back in 3-4 years and generates free power for 25 years." },
  { q: "Do solar panels need maintenance?", a: "Minimal — quarterly cleaning is enough. We offer free 1-year maintenance + 25-year panel warranty." },
];

export const BLOG_POSTS = [
  { id: "solar-subsidy-2026", title: "Solar Subsidy 2026: Complete Guide for Tamil Nadu Homes", category: "Solar", date: "Dec 2025", read: "6 min", image: IMAGES.solar, excerpt: "Everything about the PM Surya Ghar Muft Bijli Yojana — eligibility, subsidy amounts, and how to apply." },
  { id: "cctv-installation-cost", title: "CCTV Installation Cost in Tamil Nadu: 2026 Price Guide", category: "CCTV", date: "Dec 2025", read: "5 min", image: IMAGES.cctv, excerpt: "From 2MP basic kits to 5MP IP-PTZ enterprise systems — real installation prices in Thanjavur." },
  { id: "best-ev-scooter-tn", title: "Best Electric Scooter in Tamil Nadu — 2026 Buyer's Guide", category: "EV", date: "Nov 2025", read: "8 min", image: IMAGES.ev, excerpt: "Compare range, charging time, subsidy and service network across leading EV brands." },
  { id: "lithium-vs-lead-acid", title: "Lithium vs Lead-Acid Battery: Which is Right For You?", category: "Battery", date: "Nov 2025", read: "4 min", image: IMAGES.power, excerpt: "A practical breakdown of cost, lifespan, safety and total cost of ownership." },
  { id: "ev-charging-setup", title: "Setting up an EV Charging Station: Cost & ROI", category: "EV", date: "Oct 2025", read: "7 min", image: IMAGES.ev, excerpt: "AC vs DC chargers, site requirements, license, and projected returns for commercial setups." },
  { id: "smart-home-automation", title: "Smart Home Automation Trends in Tamil Nadu", category: "AI", date: "Oct 2025", read: "5 min", image: IMAGES.digital, excerpt: "How Indian homes are blending voice assistants, smart cameras, and solar inverters." },
];
